<template>
    <transition name="fade">
        <div v-show="show" class="menu-wrapper fast">
            <div class="blocker" @contextmenu.prevent="close" @click="close"></div>
            <div class="context-menu" ref="context-menu">
                <div
                    class="item"
                    v-for="(item, index) in items"
                    :key="index"
                    :style="itemStyles"
                    @click="onItemClick(item)"
                >
                    <div class="icon" v-if="item.icon">
                        <span :class="item.icon"></span>
                    </div>
                    {{ item.name }}
                    <span
                        class="far fa-angle-right submenu-indicator"
                        v-if="item.items && item.items.length"
                    ></span>
                    <div class="context-menu submenu" v-if="item.items && item.items.length">
                        <div
                            class="item"
                            v-for="(subitem, subindex) in item.items"
                            :key="subindex"
                            :style="subitemStyles[index]"
                            @click="onItemClick(subitem)"
                        >
                            <div class="icon" v-if="subitem.icon">
                                <span :class="subitem.icon"></span>
                            </div>
                            {{ subitem.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { createPopper } from '@popperjs/core';
    import { constants } from '../utils';

    export default {
        name: 'ContextMenu',
        data() {
            return {
                popper: null
            };
        },
        props: {
            show: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters({
                items: 'context/items',
                x: 'context/x',
                y: 'context/y'
            }),
            virtualElem() {
                return {
                    contextElement: document.querySelector('.canvas'),
                    getBoundingClientRect: () => ({
                        width: 0,
                        height: 0,
                        top: this.y,
                        right: this.x,
                        bottom: this.y,
                        left: this.x
                    })
                };
            },
            itemStyles() {
                return this.getItemStyles(this.items);
            },
            subitemStyles() {
                return this.items.map(item => this.getItemStyles(item.items));
            }
        },
        methods: {
            close() {
                this.$store.commit('context/set', { items: [] });
            },
            onKeydown(e) {
                if (e.which === constants.KEY_ESCAPE) {
                    this.close();
                }

                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            },
            create() {
                this.popper = createPopper(
                    this.virtualElem,
                    this.$refs['context-menu'],
                    {
                        placement: 'right-start',
                        modifiers: []
                    }
                );
            },
            destroy() {
                if (this.popper !== null) {
                    this.popper.destroy();
                    this.popper = null;
                }
            },
            onItemClick(item) {
                if (item.callback) {
                    item.callback();
                    this.close();
                }
            },
            getItemStyles(items) {
                let styles = {};
                if (!items || !items.length) return styles;
                if (items.filter(item => item.icon).length) {
                    styles.paddingLeft = '2em';
                }
                return styles;
            }
        },
        watch: {
            async show(show) {
                if (show) {
                    this.create();
                    await this.$nextTick();
                    document.body.addEventListener('keydown', this.onKeydown);
                } else {
                    this.destroy();
                    document.body.removeEventListener('keydown', this.onKeydown);
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .menu-wrapper {
        z-index: 1000;
    }

    .blocker {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: transparent;
    }

    .context-menu {
        @include border;
        @include box-shadow-small;
        @include border-radius-small;
        z-index: 106;

        &.submenu {
            position: absolute;
            top: -1px;
            left: 100%;
            pointer-events: none;
            opacity: 0;
            transition: opacity 0.2s;
        }

        .item {
            padding: 0.5em 0.75em;
            transition: background-color 0.2s;
            background-color: $color-white;
            white-space: nowrap;
            text-overflow: ellipsis;
            cursor: pointer;
            position: relative;

            &:first-child {
                border-top-left-radius: $size-border-radius-small;
                border-top-right-radius: $size-border-radius-small;
            }

            &:last-child {
                border-bottom-left-radius: $size-border-radius-small;
                border-bottom-right-radius: $size-border-radius-small;
            }

            &:hover {
                background-color: $color-disabled-bg;

                .submenu {
                    pointer-events: all;
                    opacity: 1;
                }
            }

            .icon {
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                width: 2em;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .submenu-indicator {
                margin-left: 0.5em;
            }
        }
    }
</style>